export default "__VITE_ASSET__Blds$wEy__"